import React, { useEffect } from 'react';
import Card from '../Card';
import FunFact from '../FunFact';
import Hero from '../Hero';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Cta from '../Cta';
import LogoList from '../LogoList';
import MovingText from '../MovingText';
import PortfolioSlider from '../Slider/PortfolioSlider';
import PostSlider from '../Slider/PostSlider';
import TestimonialSlider from '../Slider/TestimonialSlider';
import TeamSlider from '../Slider/TeamSlider';
import VideoModal from '../VideoModal';
import TimelineSlider from '../Slider/TimelineSlider';
import { pageTitle } from '../../helper';
// Hero Social Links
const heroSocialLinks = [
  {
    name: 'Linkedin',
    links: 'https://www.linkedin.com/company/cezzon',
  },

];

// FunFact Data
const funfaceData = [
  {
    title: 'Global Happy Clients',
    factNumber: '32',
  },
  {
    title: 'Project Completed',
    factNumber: '20+',
  },
  {
    title: 'Team Members',
    factNumber: '10+',
  },
  {
    title: 'Digital products',
    factNumber: '5+',
  },
];
const portfolioData = [
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio/portfolio-details',
    src: '/images/portfolio_1.jpeg',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio/portfolio-details',
    src: '/images/portfolio_2.jpeg',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio/portfolio-details',
    src: '/images/portfolio_0.jpg',
  },
  {
    title: 'Colorful Art Work',
    subtitle: 'See Details',
    href: '/portfolio/portfolio-details',
    src: '/images/portfolio_3.jpeg',
  },
];

export default function Home() {
  pageTitle('Home');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div
          style={{
            backgroundImage: `url(${window.innerWidth <= 768 ? "/images/tom-barrett-hgGplX3PFBg-unsplash.jpg" : "/images/slider_4.jpeg"})`,
            backgroundSize: "cover",
            backgroundPosition: window.innerWidth <= 768 ? "center" : "30% center",
            backgroundRepeat: "no-repeat",
          }}
      >
        <Hero
            title='Innovate. <span style="color: #fa186e;">Code.</span> <br/> Elevate'
            subtitle="We provide cutting-edge outsourcing solutions, leveraging automation and AI-powered tools to optimize operations and drive innovation for our clients."
            btnText="Get a Quote"
            btnLink="#contact"
            scrollDownId="#service"
            socialLinksHeading="Follow Us"
            heroSocialLinks={heroSocialLinks}
        />
      </div>
      {/* Start FunFact Section */}
      <div className="container" id='#about'>
        <FunFact
          variant="cs-type1"
          title="Our fun fact"
          subtitle="We are a technology-driven company, dedicated to building innovative and scalable solutions that empower businesses and redefine industries."
          data={funfaceData}
        />
      </div>
      {/* End FunFact Section */}

      {/* Start Service Section */}
      <Spacing lg="150" md="80" />
      <div id="services">
  <div className="container">
    <div className="row align-items-center">
      {/* Left Column: Section Heading */}
      <div className="col-xl-4">
        <SectionHeading
          title="Our Software Solutions"
          subtitle="Innovative & Scalable"
          btnText="Explore Services"
          btnLink=""
        />
        <Spacing lg="90" md="45" />
      </div>

      {/* Right Column: Service Cards */}
      <div className="col-xl-8">
        <div className="row">
          {/* Software Development */}
          <div className="col-lg-4 col-sm-6">
            <Card
              title="Software Development"
              link=""
              src="/images/app.png"
              alt="Software Development"
            />
            <Spacing lg="30" md="30" />
          </div>

          {/* Web & App Development */}
          <div className="col-lg-4 col-sm-6">
            <Card
              title="Web & App Development"
              link=""
              src="/images/web.png"
              alt="Web & App Development"
            />
            <Spacing lg="30" md="30" />
          </div>

          {/* System Automatization */}
          <div className="col-lg-4 col-sm-6">
            <Card
              title="System Automatization"
              link=""
              src="/images/automation.png"
              alt="System Automatization"
            />
            <Spacing lg="30" md="30" />
          </div>

          {/* IT Consulting */}
          <div className="col-lg-4 col-sm-6">
            <Card
              title="IT Consulting"
              link=""
              src="/images/itconsulting.png"
              alt="IT Consulting"
            />
            <Spacing lg="30" md="30" />
          </div>

          {/* Blockchain & Fintech */}
          

          {/* AI & Automation */}
          <div className="col-lg-4 col-sm-6">
            <Card
              title="Software as a Service"
              link=""
              src="/images/saas.png"
              alt="AI & Automation"
            />
            <Spacing lg="30" md="30" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      {/* End Service Section */}

      {/* Start Portfolio Section */}
    
      {/* End Portfolio Section */}

      {/* Start Awards Section */}
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_2">
        <Div className="cs-shape_2">
          <Div />
        </Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Technologies We Use"
          subtitle="Our Tech Stack"
                variant="cs-style1"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <TimelineSlider />
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Awards Section */}

      {/* Start Video Block Section */}
      <Spacing lg="130" md="70" />
      <Div className="container">
        <h2 className="cs-font_50 cs-m0 text-center cs-line_height_4">
        We embrace continuous improvement, adaptability, and innovation to deliver cutting-edge solutions that evolve with your needs.
        </h2>
        <Spacing lg="70" md="70" />
      
      </Div>
      {/* End Video Block Section */}

      {/* Start Team Section */}
     

      {/* Start Blog Section */}
   

      {/* Start MovingText Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="We bring innovation" />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Let’s disscuse make <br />something <i>cool</i> together"
          btnText="Apply For Meeting"
          btnLink=""
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
